export default __webpack_public_path__ + "static/azalea-carbonara-f80da4d0bf6a00829d3ccc5f9f568831.jpg";